module.exports = __webpack_public_path__ + "img/unsorted-icon.47a7681a.svg";